
// Angular
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { RequestResult } from '@app/core/dto/RequestResult';
import { SessionStorageService } from '@app/core/services/session-storage.service';
import { PushNotifParameters } from '@app/kip/dto/PushNotifParameters';
import { UserParameter } from '@app/kip/dto/UserParameter';
import { UserParameterService } from '@app/kip/services/user-parameter.service';
import { TopBarManagerService } from '@core/services/topbar-manager.service';
import { AuthService } from '@core/services/auth.service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { UserInfo } from 'os';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { HwAlertService } from '@globalshared/hw-alert-component/src/lib/hw-alert.service';
import { Alert, ToastPosition } from '@globalshared/hw-alert-component/src/lib/hw-alert.model';

// 3rdparty

// Hostware

@AutoUnsubscribe()
@Component({
  selector: 'app-push-notif-parameters-editor',
  templateUrl: './push-notif-parameters-editor.component.html',
  styleUrls: ['./push-notif-parameters-editor.component.scss']
})
export class PushNotifParametersEditorComponent implements OnInit, AfterViewInit, OnDestroy {
  editorForm: FormGroup
  pushNotifParameters: PushNotifParameters = new PushNotifParameters();
  userParameter: UserParameter = new UserParameter();
  loadParameters$: Subscription;
  saveParameters$: Subscription;
  hotelUnitChanged$: Subscription;
  //#region =============== Angular Lifecyle events ============================================================================

  /**
   *
   */
  constructor(
    private fb: FormBuilder,
    private userParameterService: UserParameterService,
    private topBarService: TopBarManagerService,
    private sessionStorageService: SessionStorageService,
    private topBarManagerService: TopBarManagerService,
    private authService: AuthService,
    private chd: ChangeDetectorRef,
    private hwAlertService: HwAlertService,
    private translate: TranslateService
  ) {
    this.editorForm = this.fb.group({
      PushEnabled: new FormControl(false),
      HKTaskStateChanges_New: new FormControl('O'),
      HKTaskStateChanges_AssignedToChanged: new FormControl('O'),
      HKTaskStateChanges_SupervisorChanged: new FormControl('O'),
      HKTaskStateChanges_Ended: new FormControl('O'),
      HKTaskStateChanges_Inspected: new FormControl('O'),
      MTaskStateChanges_New: new FormControl('O'),
      MTaskStateChanges_AssignedToChanged: new FormControl('O'),
      MTaskStateChanges_SupervisorChanged: new FormControl('O'),
      MTaskStateChanges_Ended: new FormControl('O'),
      MTaskStateChanges_Inspected: new FormControl('O'),
      RoomStateChanges_Dirty: new FormControl('O'),
      RoomStateChanges_Clean: new FormControl('O'),
      RoomStateChanges_Inspected: new FormControl('O'),
      RoomStateChanges_OOO: new FormControl('O'),
      RoomReservationChanges_Arrived: new FormControl('O'),
      RoomReservationChanges_CheckedOut: new FormControl('O'),
      RoomReservationChanges_LateCheckout: new FormControl('O')
    });
  }

  ngOnInit(): void {
    this.loadAll();
    // Option group controlok nevei
    const optionGroups = [
      'HKTaskStateChanges_New',
      'HKTaskStateChanges_AssignedToChanged',
      'HKTaskStateChanges_SupervisorChanged',
      'HKTaskStateChanges_Ended',
      'HKTaskStateChanges_Inspected',
      'MTaskStateChanges_New',
      'MTaskStateChanges_AssignedToChanged',
      'MTaskStateChanges_SupervisorChanged',
      'MTaskStateChanges_Ended',
      'MTaskStateChanges_Inspected',
      'RoomStateChanges_Dirty',
      'RoomStateChanges_Clean',
      'RoomStateChanges_Inspected',
      'RoomStateChanges_OOO',
      'RoomReservationChanges_Arrived',
      'RoomReservationChanges_CheckedOut',
      'RoomReservationChanges_LateCheckout'
    ];

    // Segédfüggvény az összes optiongroup enable/disable-ére
    const setOptionGroupsDisabled = (disabled: boolean) => {
      optionGroups.forEach(name => {
        const ctrl = this.editorForm.get(name);
        if (ctrl) {
          if (disabled) {
            ctrl.disable({ emitEvent: false });
          } else {
            ctrl.enable({ emitEvent: false });
          }
        }
      });
    };

    // Kezdeti állapot beállítása
    setOptionGroupsDisabled(!this.editorForm.get('PushEnabled')?.value);

    // Feliratkozás a PushEnabled változásaira
    this.editorForm.get('PushEnabled')?.valueChanges.subscribe((val: boolean) => {
      setOptionGroupsDisabled(!val);
    });
    this.topBarService.hotelUnitChanged.subscribe(hotelUnit => {
      this.loadAll();
    });
  }
  ngAfterViewInit(): void {
    this.chd.detectChanges();
    //   this.editorForm.controls['PushEnabled'].patchValue(false);
  }
  ngOnDestroy(): void {
    this.loadParameters$?.unsubscribe();
    this.saveParameters$?.unsubscribe();
  }
  //#endregion =================================================================================================================

  //#region =============== List event hadlers   ===============================================================================
  //#endregion =================================================================================================================

  //#region =============== Form events ========================================================================================
  cancel() {

  }
  submit() {
    this.topBarManagerService.setPushStatus(this.editorForm.get('PushEnabled')?.value);
    this.pushNotifParameters = this.editorForm.getRawValue();
    this.userParameter.Param_Json_Value = JSON.stringify(this.pushNotifParameters);
    this.saveParameters$ = this.userParameterService.update(this.userParameter).subscribe((data: RequestResult) => {

      if(data.Code == 0) {
          this.hwAlertService.info(this.translate.instant("common.saved_successfully"), new Alert({ autoClose: true, fade: true, position: ToastPosition.TopRight }));
      } else {
        this.hwAlertService.error(this.translate.instant("common.error_while_performing_operation"), new Alert({ autoClose: false, fade: true, position: ToastPosition.TopRight }));
      }
    });

  }

  loadAll() {
    this.loadParameters$ = this.userParameterService.loadByTypeCode(this.sessionStorageService.getSelectedUnit(), this.sessionStorageService.getSelectedHotelId(),
      this.authService.getEmailFromToken(), "PUSH_PARAMETER").subscribe((data: RequestResult) => {
        if (data) {
          this.userParameter = data.Data as UserParameter;
          this.pushNotifParameters = JSON.parse(this.userParameter.Param_Json_Value);
          this.editorForm.patchValue(this.pushNotifParameters);
        }
      });
  }
  //#endregion =================================================================================================================

  //#region =============== Dialog events ======================================================================================
  //#endregion =================================================================================================================

  //#region =============== Validation    ======================================================================================
  //#endregion =================================================================================================================

  //#region =============== Functions  =========================================================================================
  defaultValue() {

  }
  //#endregion =================================================================================================================
}
